import { render, staticRenderFns } from "./fa-phone.vue?vue&type=template&id=e87f2fba&"
import script from "./fa-phone.vue?vue&type=script&lang=js&"
export * from "./fa-phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports